import AppStoreBadgeIcon from "../../assets/icons/AppStoreBadgeIcon";
import GooglePlayBadgeIcon from "../../assets/icons/GooglePlayBadgeIcon";
import SeriesCoinModalIcon from "../../assets/icons/SeriesCoinModalIcon";
import React from "react";
import { Link } from "react-router-dom";

type SeriesCoinModalContentProps = {
  title: string;
  subtitle: string;
  detail: string;
  appStoreUrl: string;
  googlePlayUrl: string;
};

const SeriesCoinModalContent = ({
  title,
  subtitle,
  detail,
  appStoreUrl,
  googlePlayUrl,
}: SeriesCoinModalContentProps) => (
  <div className="series-coin-modal__content">
    <div className="series-coin-modal__icon" aria-hidden="true">
      <SeriesCoinModalIcon />
    </div>
    <h4 className="series-coin-modal__title">{title}</h4>
    <p className="series-coin-modal__subtitle">{subtitle}</p>
    <div className="series-coin-modal__divider" />
    <p className="series-coin-modal__detail">{detail}</p>
    <div className="series-coin-modal__stores">
      <Link
        to={appStoreUrl}
        target="_blank"
        className="series-coin-modal__store-button"
      >
        <AppStoreBadgeIcon aria-hidden="true" />
      </Link>
      <Link
        to={googlePlayUrl}
        target="_blank"
        className="series-coin-modal__store-button"
      >
        <GooglePlayBadgeIcon aria-hidden="true" />
      </Link>
    </div>
  </div>
);

export default SeriesCoinModalContent;
